import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionSection } from './components/SolutionSection';
import { ReviewsSection } from './components/ReviewsSection';
import { IncludesSection } from './components/IncludesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { CtaSection } from './components/CtaSection';
import { UrgencySection } from './components/UrgencySection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <main className="min-h-screen w-full font-inter text-brown-light bg-cream selection:bg-gold-start/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <AgitationSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ReviewsSection data-id="element-5" />
      <IncludesSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <CtaSection data-id="element-9" />
      <UrgencySection data-id="element-10" />

      <SocialProofPopup data-id="element-11" />
    </main>;
}